const ModalHeader = (props) => {

    return (<div style={{
        width: "100%",
        height: "2rem",
        marginBottom: "1rem",
        backgroundColor: "#ddd",
        padding: "0.5rem 1.25rem",
        marginTop: "-1.25rem",
        display: "flex",
        alignItems: "center"
    }}>
        <h3 style={{fontFamily: "sans-serif", fontSize: "1.5rem", color: "var(--primary-blue"}}>Chess Corner</h3>
    </div>)
}

export default ModalHeader;